export const trackGoogleAnalytics = (): void => {
	// Track google analytics without specific userIDs (how we were doing it before big herballife event, just general
	// tracking)
	window.ga("create", "UA-17269713-1", "auto");
	window.ga("send", "pageview");
};